module.exports = __webpack_public_path__ + "img/boat-13.d7c0b2e2.jpg";